import React, { useState } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import SuggestedSection from './SuggestedSection'
import { makeAiAnalysisQueryClient } from '../queryClient'
import type { AiSuggestedSectionProps } from './SuggestedSection'

const AiSuggestedSectionWrapper: React.FC<AiSuggestedSectionProps> = (props) => {
  const [queryClient] = useState(makeAiAnalysisQueryClient)

  return (
    <QueryClientProvider client={queryClient}>
      <SuggestedSection {...props} />
    </QueryClientProvider>
  )
}

export default AiSuggestedSectionWrapper
